module.exports = "<svg viewBox=\"0 0 18 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 0H18V2H0V0Z\" fill=\"white\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader!./minus.svg
// module id = 3
// module chunks = 0